<template>
  <v-carousel
    v-resize="onResize"
    :show-arrows="false"
    :height="windowSize.y - 55"
    cycle
  >
    <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
      <v-row
        :align="item.align"
        :justify="item.justify"
        class="lightbox white--text ma-2 pa-2 fill-height"
      >
        <v-col class="ma-8" col="12" sm="8" md="6" lg="4">
          <v-card color="rgba(10, 23, 55, 0.5)" dark>
            <v-card-title class="headline"
              ><span class="fontvn" v-if="item.title === 'Violent Noise'">{{
                item.title
              }}</span>
              <span v-if="item.title !== 'Violent Noise'">{{
                item.title
              }}</span></v-card-title
            >

            <v-card-subtitle v-html="item.subtitle"></v-card-subtitle>

            <v-card-text v-html="item.body"> </v-card-text>

            <v-card-actions v-if="item.showpage !== 'none'">
              <v-btn text @click="showMenu(item.title)">{{item.showpage}}</v-btn>
            </v-card-actions>

            <v-card-actions v-if="item.title === 'Facebook'">
              <iframe
                src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com.br%2Fviolent-noise-blog&width=100&layout=button&action=like&size=small&share=true&height=65&appId"
                width="157"
                height="65"
                style="border:none;overflow:hidden"
                scrolling="no"
                frameborder="0"
                allowTransparency="true"
                allow="encrypted-media"
              ></iframe>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
// @ is an alias to /src

const image1 = require("@/assets/images/carousel/show.jpg");
const image2 = require("@/assets/images/carousel/drums.jpg");
const image3 = require("@/assets/images/carousel/artist-back-view.jpg");
const image4 = require("@/assets/images/carousel/people.jpg");

export default {
  components: {},
  data() {
    return {
      windowSize: {
        x: 0,
        y: 600
      },
      items: [
        {
          //src: require("@/assets/images/carousel/audience-celebration.jpg"),
          src: image1,
          title: "Violent Noise",
          subtitle: "Onde o Rock é essencial.",
          body:
            "O <span style=\"font-family: 'Fontdiner Swanky', serif;\">VIOLENT NOISE</span> foi idealizado e criado por Pierre Cortes. Paulistano, apreciador do Rock, Metal e suas subdivisões desde o início dos anos 80, o objetivo de criar o projeto foi justamente a necessidade de difundir, fortalecer e compartilhar o cenário Underground e as bandas que dele fazem parte. Stay Rock!",
          showpage: 'none',
          align: "center",
          justify: "start"
        },
        {
          //src: require("@/assets/images/carousel/audio-cassette.jpg"),
          src: image2,
          title: "Blog Drops",
          subtitle: "",
          body:
            "Visite nosso blog para saber das principais novidades do Rock nacional e internacional",
          showpage: 'Visualizar',
          align: "start",
          justify: "start"
        },
        {
          //src: require("@/assets/images/carousel/band-bright.jpg"),
          src: image3,
          title: "Facebook",
          subtitle: "",
          body:
            "Acompanhe as noticias no Facebook, curta nossa pagina e nos acompanhe",
          showpage: 'Visualizar',
          align: "center",
          justify: "end"
        },
        {
          //src: require("@/assets/images/carousel/black-and-white.jpg"),
          src: image4,
          title: "Patrocinio",
          subtitle: "Seja nosso patrocinador",
          showpage: 'Saiba mais...',
          body:
            "O <span style=\"font-family: 'Fontdiner Swanky', serif;\">VIOLENT NOISE</span> é um espaço independente e feito para os fãs e músicos das bandas. Sua ajuda será muito bem-vinda, pois isso irá auxiliar nos custos de manutenção do site. Quer e pode contribuir?",
          align: "center",
          justify: "start"
        }
      ]
    };
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
     showMenu: function(title) {
      this.drawer = false;

      if (title === "Blog Drops") {
        this.$store.commit("setIsBlogPost", true);
      } else if (title === "Facebook") {
        this.$store.commit("setIsFacebook", true);
      } else if (title === "Patrocinio") {
        this.$store.commit("setIsPatrocinador", true);
      }
    },
  }
};
</script>

<style scoped>
.fontvn {
  font-family: "Fontdiner Swanky", serif;
}

.quadro {
  opacity: 0.3;
  filter: alpha(opacity=30); /* For IE8 and earlier */
  text-decoration-color: white;
  background-color: black;
}

.quadro3 {
  background-color: rgba(10, 23, 55, 0.5) !important;
}

.quadro2 {
  opacity: 1 !important;
  filter: alpha(opacity=100); /* For IE8 and earlier */
  text-decoration-color: white;
}
</style>
